import { Koi } from '@ksyos/koi';

export interface IDiagnosisAddEditValidated {
    considerationThesaurusTermId: string | null;
    diagnosisConsiderationIcd10: string | null;
    diagnosisConsiderationIcd10fallback?: string | null;
    diagnosisDifferentialConsiderationIcd10a: string | null;
    diagnosisDifferentialConsiderationIcd10b: string | null;
    diagnosisDifferentialConsiderationIcd10c: string | null;
    differentialConsiderationThesaurusTermIda: string | null;
    differentialConsiderationThesaurusTermIdb: string | null;
    differentialConsiderationThesaurusTermIdc: string | null;
}

export const diagnosisSchema = Koi.object({
    considerationThesaurusTermId: Koi.string().max(255).allow(null),
    diagnosisConsiderationIcd10: Koi.string().max(255).allow(null),
    diagnosisConsiderationIcd10fallback: Koi.string().max(255).allow(null).optional(),
    diagnosisDifferentialConsiderationIcd10a: Koi.string().max(255).allow(null),
    diagnosisDifferentialConsiderationIcd10b: Koi.string().max(255).allow(null),
    diagnosisDifferentialConsiderationIcd10c: Koi.string().max(255).allow(null),
    differentialConsiderationThesaurusTermIda: Koi.string().max(255).allow(null),
    differentialConsiderationThesaurusTermIdb: Koi.string().max(255).allow(null),
    differentialConsiderationThesaurusTermIdc: Koi.string().max(255).allow(null),
});

export const nullDiagnosis: Omit<IDiagnosisAddEditValidated, 'diagnosisConsiderationIcd10fallback'> = {
    considerationThesaurusTermId: null,
    diagnosisConsiderationIcd10: null,
    diagnosisDifferentialConsiderationIcd10a: null,
    diagnosisDifferentialConsiderationIcd10b: null,
    diagnosisDifferentialConsiderationIcd10c: null,
    differentialConsiderationThesaurusTermIda: null,
    differentialConsiderationThesaurusTermIdb: null,
    differentialConsiderationThesaurusTermIdc: null,
};
